import { Component } from 'react'
import { Box, Link, Heading } from 'theme-ui'

// Synos footer for the public pages of the admin app (sign in, sign out).
// The legal texts live on synos.pt so there is a single version of each.
class Header extends Component {
  render() {
    return (
      <Box sx={{ mt: [3, null, 4] }}>
        <Heading as="h3" sx={{ fontSize: [4], lineHeight: 'body', my: [2, null, 3] }}>
          Legal
        </Heading>
        <Box sx={{ mb: [2, null, 3], maxWidth: ['100%', '100%', '30em'] }}>
          Synos · construído sobre tecnologia open-source{' '}
          <Link href="https://pol.is" target="_blank" rel="noopener">
            Polis
          </Link>
        </Box>
        <Box sx={{ mb: [2, null, 3] }}>
          © {new Date().getFullYear()} Synos ·{' '}
          <Link href="https://synos.pt/termos/">Termos de Utilização</Link> ·{' '}
          <Link href="https://synos.pt/privacidade/">Política de Privacidade</Link>
        </Box>
      </Box>
    )
  }
}

export default Header
